import { useQuery } from "@tanstack/react-query";
import {
  IMemberLoginHistoryPostModel,
  IMemberStatusCountGridPostModel,
  IYearWiseMemberGridPostModel,
  ILoginHistoryPostModel,
} from "./types";
import api from "./requests";

export function GetMembers(model: IMemberStatusCountGridPostModel) {
  const query = useQuery({
    queryKey: ["getMembers"],
    queryFn: () => api.getMemberStatusCount(model),
  });
  return query;
}

export function GetYearWiseMember(model: IYearWiseMemberGridPostModel) {
  const query = useQuery({
    queryKey: ["getYearWiseMembers"],
    queryFn: () => api.getYearWiseMemberCount(model),
  });
  return query;
}

export function GetLogedInMembers(model: IMemberLoginHistoryPostModel) {
  const query = useQuery({
    queryKey: ["getLogedInMembers"],
    queryFn: () => api.getLogedInMembers(model),
  });
  return query;
}

export function GetLoginHistoryList(model: ILoginHistoryPostModel) {
  const query = useQuery({
    queryKey: ["getLoginHistoryList", model],
    queryFn: () => api.getLoginHistoryList(model),
  });
  return query;
}

export function GetMemberWiseTables() {
  const query = useQuery({
    queryKey: ["getMemberWiseTableResults"],
    queryFn: () => api.getMemberWiseTables(),
  });
  return query;
}

export function GetIndustryWiseMember() {
  const query = useQuery({
    queryKey: ["getIndustryWiseMember"],
    queryFn: () => api.getIndustryWiseMember(),
  });
  return query;
}

export function GetPendingApprovalCounts() {
  const query = useQuery({
    queryKey: ["getPendingApprovalCounts"],
    queryFn: () => api.getPendingApprovalCounts(),
    refetchInterval: 30000, // optionally auto refetch every 30 seconds
  });
  return query;
}
